import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { CustomTimeoutError, Error, MonitoringService } from '@bilancio/api';
import { ErrorSandbox } from './error.sandbox';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  private readonly interceptorCode = [403, 404, 422];
  constructor(private readonly injector: Injector) {
    super();
  }

  handleError(error: Error) {
    console.error(error);
    const monitoringService = this.injector.get(MonitoringService);
    monitoringService.logException(error);
    monitoringService.flush();
    let showMessagePage = false;
    const errorObj: Error.ErrorObj = {
      errorCode: 0,
      errorMessage: error?.message,
      errorBoldMsg: '',
      errorStack: error?.stack,
      errorImg: 'Illustrazione-errore.svg',
      errorDate: new Date(),
    };
    const sandbox = this.injector.get(ErrorSandbox);
    if (error instanceof CustomTimeoutError) {
      sandbox.showToast(
        'La chiamata a ' +
          error.endPoint +
          " ci ha messo troppo tempo ad essere eseguita. Riprova ad eseguire l'operazione",
      );
    } else if (error instanceof HttpErrorResponse)
      if (error.status === 422) {
        errorObj.errorMessage = error.error || 'Errore di licenza';
        errorObj.errorCode = error.status;
        errorObj.errorStack = JSON.stringify(error);
        sandbox.showToast(error.error);
      } else if (this.interceptorCode.indexOf(error.status) < 0) {
        errorObj.errorCode = error.status;
        errorObj.errorMessage = sandbox.getMessage(error.status);
        errorObj.errorStack = JSON.stringify(error);
        errorObj.errorImg = sandbox.getImage(error.status);
        showMessagePage = true;
      } else if (!(error instanceof HttpErrorResponse)) {
        errorObj.errorMessage = 'Ops! Qualcosa è andato storto…';
        showMessagePage = true;
      }
    errorObj.errorBoldMsg = sandbox.getBoldMessage(errorObj.errorCode);
    if (showMessagePage) {
      sandbox.manageError(errorObj);
    }
  }
}
